/**
 * Product page accordion rows show metafields through dynamic sources, e.g.
 * "Material: {{ closest.product.metafields.custom.material.value }}". When a product
 * has no value for that metafield, the line renders as a dangling "Material:".
 * Hide those label-only lines, and hide an accordion row entirely when every line
 * in it ended up hidden.
 */

const LABEL_ONLY = /^[^:]*:\s*$/;

function hideEmptyMetafieldRows() {
  for (const item of document.querySelectorAll('.text-block.rte :is(li, p)')) {
    if (LABEL_ONLY.test(item.textContent)) item.hidden = true;
  }

  for (const row of document.querySelectorAll('details.details')) {
    const content = row.querySelector('.details-content');
    if (!content) continue;

    const lines = content.querySelectorAll('.text-block.rte :is(li, p)');
    if (lines.length === 0) continue;

    const allHidden = [...lines].every((line) => line.hidden || line.closest('[hidden]'));
    if (allHidden) row.hidden = true;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideEmptyMetafieldRows, { once: true });
} else {
  hideEmptyMetafieldRows();
}
